import * as tslib_1 from "tslib";
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'environments/environment';
import { map } from 'rxjs/operators';
import { PrintableDocument } from '@sc/portal.fe.lib.app-components';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var PolicyDocumentsService = /** @class */ (function () {
    function PolicyDocumentsService(http) {
        this.http = http;
    }
    PolicyDocumentsService.prototype.getDocuments = function (policyNumber) {
        var params = new HttpParams({ fromObject: { policyNumber: policyNumber } });
        return this.http
            .get(environment.server.api.portalpas + "/documents/DocumentsByPolicyNumber", { params: params })
            .pipe(map(function (response) {
            return response.documents.map(function (each) {
                return new PrintableDocument(tslib_1.__assign({}, each, { name: policyNumber }));
            });
        }));
    };
    PolicyDocumentsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PolicyDocumentsService_Factory() { return new PolicyDocumentsService(i0.ɵɵinject(i1.HttpClient)); }, token: PolicyDocumentsService, providedIn: "root" });
    return PolicyDocumentsService;
}());
export { PolicyDocumentsService };
